import { useState, useEffect } from "react";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { Layout, Overlay } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { next, close } = props;
  const { scale } = useScale();
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById("project-preview-panel");
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x - 75 * scale,
        y: rect.y - 75 * scale,
        width: rect.width + 150 * scale,
        height: rect.height + 150 * scale,
      });
    }, 300);
  }, [scale]);

  return (
    <>
      <Overlay area={panelRect}>
        <></>
      </Overlay>

      <Layout transparent position={{ x: 10, y: 10 }} next={next} close={close}>
        <Title activeStep={10} />

        <div className="flex-col-el items-start justify-center w-[312px]">
          <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
            {I18n.locale === "ja"
              ? "アプリの がめんが\nひょうじ されました！"
              : "アプリの画面が\n表示されました！"}
          </p>
        </div>
      </Layout>
    </>
  );
};

export default Step;
